import {
    ColumnAlignment,
    type EditableListColumnConfig,
    EditableListItemRenderAs,
} from "../../../../../components/EditableList/types/EditableListConfig";
import { FormComponent } from "../../../../../components/Form/types/types";

export const columnsConfig2: EditableListColumnConfig[] = [
    {
        alignment: ColumnAlignment.CENTER,
        title: "dataGroups.appConfigs.hidden",
        width: 0,
        type: EditableListItemRenderAs.HIDDEN,
        field: {
            name: "name",
            component: FormComponent.HIDDEN_INPUT,
            translationKeys: {
                label: "dataGroups.appConfigs.hidden",
            },
        },
    },
    {
        alignment: ColumnAlignment.CENTER,
        title: "dataGroups.appConfigs.name",
        width: 3,
        type: EditableListItemRenderAs.TEXT,
        field: {
            name: "displayName",
            component: FormComponent.DISPLAY_TEXT,
            translationKeys: {
                label: "dataGroups.appConfigs.name",
            },
        },
    },
    {
        alignment: ColumnAlignment.CENTER,
        title: "dataGroups.appConfigs.component",
        width: 6,
        type: EditableListItemRenderAs.TEXT,
        field: {
            name: "component",
            component: FormComponent.DISPLAY_TEXT,
            translationKeys: {
                label: "dataGroups.appConfigs.component",
            },
        },
    },
    {
        alignment: ColumnAlignment.CENTER,
        title: "dataGroups.appConfigs.isIncluded",
        width: 3,
        type: EditableListItemRenderAs.BOOLEAN,
        field: {
            name: "isIncluded",
            component: FormComponent.CHECK_BOX,
            translationKeys: {
                label: "dataGroups.appConfigs.isIncluded",
            },
        },
    },
    {
        alignment: ColumnAlignment.LEFT,
        title: "dataGroups.appConfigs.validations",
        width: 4,
        type: EditableListItemRenderAs.VALIDATIONS_VIEW,
        field: {
            name: "validations",
            component: FormComponent.APPLICATION_CONFIGURATIONS_VALIDATIONS_EDIT,
            translationKeys: {
                label: "dataGroups.appConfigs.validations",
            },
        },
    },
    {
        alignment: ColumnAlignment.LEFT,
        title: "dataGroups.appConfigs.defaultValue",
        width: 4,
        type: EditableListItemRenderAs.DEFAULT_VALUE_VIEW,
        field: {
            name: "defaultValue",
            component: FormComponent.APPLICATION_CONFIGURATIONS_DEFAULT_VALUE_EDIT,
            translationKeys: {
                label: "dataGroups.appConfigs.defaultValue",
            },
        },
    },
];
